import React, { Fragment, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../../services/api';
import { ContentTitle } from '../../utilities/styledComponents/ContentTitle';
import * as Home from './style/StyledBackofficeHome';
import BoxMessage from '../../BoxMessage';
import config from '../../../config/environments';
import logo from '../../../img/logo.png';

const BoxMessageContent = () => (
	<Fragment>
		<img src={logo} alt="Logo gearbox" />
		<h3>Backoffice Gearbox!</h3>
		<p>
			Seja bem-vindo ao BackOffice do Gearbox. Aqui fará parte da
			sua central de trabalho, os briefings,
			os clientes, está tudo aqui. Espero que
			goste de utilizar este BackOffice!
		</p>
	</Fragment>
);

const BackofficeHome = () => {
	const [demandStatus, setDemandStatus] = useState([]);
	useEffect(() => {
		api.get(`${config.APIUrl}/demand-status?with_demands=true`)
			.then((res) => {
				setDemandStatus(res.data.data);
			});
	}, []);

	return (
		<div>
			<div className="page-container ">
				<article className="position-relative" id="home-page">
					<div className="content-welcome p-0">
						<ContentTitle>Bem vindo ao backoffice</ContentTitle>
						<div className="container-fluid">
							<article className="containerHome">
								<section className="contentHome">
									<div className="row">
										<div className="col">
											<BoxMessage>
												<BoxMessageContent />
											</BoxMessage>
										</div>
									</div>
									<div className="row">
										{demandStatus.map(info => (
											<Home.Card key={info.id} className="col-xs-12 col-sm-6 col-md-4 col-lg-3">
												<div style={{

												}}
												>
													<div className="row">
														<Home.CardCounter
															className="col-sm-12"
														>
															<em>{info.attributes.demands_count}</em>
														</Home.CardCounter>
													</div>
													<div className="row">
														<Home.CardStatus
															className="col-sm-12"
														>
															<em>{info.attributes.title}</em>
														</Home.CardStatus>
													</div>
													<div className="row ">
														<div className="col-sm-12 mt-3">
															<Link
																to={`/backoffice/demandas?status=${info.id}`}
																className="btn btn-danger btn-block btn-lg"
																style={{
																	fontFamily: 'Poppins, Heltica, Arial, sans-serif',
																	fontSize: '14px',
																	cursor: 'pointer',
																	backgroundColor: '#FF0E4C',
																}}
															>
																Tratar demandas
															</Link>
														</div>
													</div>
												</div>
											</Home.Card>
										))}
									</div>
								</section>
							</article>
						</div>
					</div>
				</article>
			</div>
		</div>
);
};

export default BackofficeHome;
